import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { iconSeverityPicker } from '../../helpers/IconHelper';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: 44,
    backgroundColor: (props) => {
      switch (props.severity) {
        case 'success':
          return '#4caf50';
        case 'error':
          return '#f44336';
        default:
          return '#f44336';
      }
    },
    color: 'white',
  },
  image: {
    width: 20,
    height: 20,
    marginRight: 12,
  },
}));

const Alert = ({ ...props }) => {
  const { severity, message } = props;
  const classes = useStyles({ severity: severity });
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      className={classes.container}
    >
      <img src={iconSeverityPicker(severity)} className={classes.image} />
      <Typography variant="h5">{message}</Typography>
    </Box>
  );
};

Alert.propTypes = {
  severity: PropTypes.string,
  message: PropTypes.string,
};

export default Alert;
